<template>
    <div class="info">
      <template v-if="type === 'job'">
        <p class="title">任职资格：</p>
        <p v-html="info.description.replace(/\n/g, '<br/>')"></p>
        <p class="title">岗位职能：</p>
        <p  v-html="info.requirements.replace(/\n/g, '<br/>')"></p>
        <p class="title">岗位福利：</p>
        <template v-if="salary_benefits">
          <p v-if="salary_benefits.pre_tax_salary">税前薪资：{{ salary_benefits.pre_tax_salary.min }}K~{{ salary_benefits.pre_tax_salary.max }}K*{{salary_benefits.pre_tax_salary.month_count}}月</p>
         
          <p v-if="salary_benefits.salary_structure && salary_benefits.salary_structure.sels">薪资构成：{{ salary_benefits.salary_structure.sels.join(',') }}
            <span v-if="salary_benefits.salary_structure.other">{{ ',' + salary_benefits.salary_structure.other}}</span>
          </p>
  
          <p v-if="salary_benefits.social_benefits && salary_benefits.social_benefits.sels">社保福利：{{ salary_benefits.social_benefits.sels.join(',') }}
            <span v-if="salary_benefits.social_benefits.other">{{ ',' + salary_benefits.social_benefits.other}}</span>
          </p>
  
          <p v-if="salary_benefits.live_benefits && salary_benefits.live_benefits.sels">居住福利：{{ salary_benefits.live_benefits.sels.join(',') }}
            <span v-if="salary_benefits.live_benefits.other">{{ ',' + salary_benefits.live_benefits.other}}</span>
          </p>
          <p v-if="salary_benefits.vacation_benefits && salary_benefits.vacation_benefits.sels">年假福利：{{ salary_benefits.vacation_benefits.sels.join(',') }}
            <span v-if="salary_benefits.vacation_benefits.other">{{ ',' + salary_benefits.vacation_benefits.other}}</span>
          </p>
          <p v-if="salary_benefits.traffic_benefits && salary_benefits.traffic_benefits.sels">通讯交通：{{ salary_benefits.traffic_benefits.sels }}</p>
        </template>

        <template>
          <div ref="candidate" id = "candidate" style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
            <p class="title">其他候选人要求：</p>
             <template v-if = "candidateEdit == true">
        
             <div style="display: flex; flex-direction: row;">
              <button class="title" style="font-size: 14px;" @click="editCancelAct">取消</button>
              <div style="width: 10px;"></div>
              <button class="title" style="font-size: 14px;" @click="editDoneAct">完成</button>
             </div>
            </template>
            <template v-else>
              <button class="title" style="font-size: 14px;" @click="editAct">编辑</button>
            </template>
           
          </div>

        
          <!-- 编辑 -->
          <template v-if = "candidateEdit == true">
            <postEdit :vType = "2" :job_id = "info.id" ref="candidateRef" @editFinish = "editFinish" :job_data = "info"></postEdit>
          </template>
          <!-- 展示 -->
          <template v-else>
              <AITwoDisplayRow title="年龄要求" :aiText="`${info.ai_advices.age_requirement_min}~${info.ai_advices.age_requirement_max}岁` " :text = "`${info.age_requirement_min}~${info.age_requirement_max}岁` " :isAI="info.ai_advices.aiStatusAgeRequirementMin == 1 && info.ai_advices.aiStatusAgeRequirementMax == 1"/>
              <AITwoDisplayRow title="是否统招" :aiText="handleIsTongZhao(info.ai_advices.aiStatusFullTimeType)" :text="handleIsTongZhao(info.full_time_type)" :isAI="info.ai_advices.aiStatusFullTimeType == 1" />
              <AITwoDisplayRow title="所学专业" :aiText="info.ai_advices.candidate_major" :text = "info.candidate_major" :isAI="info.ai_advices.aiStatusMajorRequirement == 1" />
              <AITwoDisplayRow title="语言要求" :aiText="handleLanguage(info.ai_advices.language_requirement)" :text="handleLanguage(info.language_requirement)" :isAI="info.ai_advices.aiStatusLanguageRequirement == 1" />
              <AITwoDisplayRow title="行业要求" :aiText="handleIndustry(info.ai_advices.job_industrys)" :text = "handleIndustry(info.job_industrys)" :isAI="info.ai_advices.aiStatusIndustry == 1" />
              <AITwoDisplayRow title="技能要求" :aiText="info.ai_advices.requirement_skill" :text = "info.requirement_skill" :isAI="info.ai_advices.aiStatusRequirementSkill == 1" />
              <AITwoDisplayRow title="性别要求" :aiText="this.handleGender(info.ai_advices.gender_id)" :text = "this.handleGender(info.gender_id)" :isAI="info.ai_advices.aiStatusGenderId == 1 "/>
              <AITwoDisplayRow title="学校类型" :aiText="this.handleShool(info.ai_advices.school_type)" :text="this.handleShool(info.school_type)" :isAI="info.ai_advices.aiStatusSchoolType == 1" />
          </template>
    
        </template>
        
  
        <template v-if="Object.keys(info.draw_portrait_inactive_tag).length || Object.keys(info.draw_portrait_active_tag).length">
          <p class="title">候选人画像：</p>
          <p class="flex"
            v-if="handleBorn(info.draw_portrait_inactive_tag, 'inactive') || handleBorn(info.draw_portrait_active_tag, 'active')"
          >
            <span>不考虑出生地: {{ handleBorn(info.draw_portrait_inactive_tag, 'inactive') }}</span>
            <span>优先考虑: {{ handleBorn(info.draw_portrait_active_tag, 'active') }}</span>
          </p>
          <p class="flex"
            v-if="info.draw_portrait_inactive_tag.inactive_gender_id"
          >
            <span>不考虑性别: {{ info.draw_portrait_inactive_tag.inactive_gender_id == 1 ? '男' : info.draw_portrait_inactive_tag.inactive_gender_id == 2 ? '女' : '未知' }}</span>
          </p>
          <p class="flex"
            v-if="info.draw_portrait_inactive_tag.inactive_job_hopping_interval || info.draw_portrait_active_tag.active_job_hopping_interval"
          >
            <span>不考虑频繁跳槽: {{ job_hopping_interval[info.draw_portrait_inactive_tag.inactive_job_hopping_interval] }}</span>
            <span>优先考虑: {{ job_hopping_interval[info.draw_portrait_active_tag.active_job_hopping_interval] }}</span>
          </p>
          <p class="flex"
            v-if="info.draw_portrait_inactive_tag.inactive_zodiac_sign || info.draw_portrait_active_tag.active_zodiac_sign"
          >
            <span>不考虑生肖: {{ zodiac_sign[info.draw_portrait_inactive_tag.inactive_zodiac_sign] }}</span>
            <span>优先考虑: {{ zodiac_sign[info.draw_portrait_active_tag.active_zodiac_sign] }}</span>
          </p>
          <p class="flex"
            v-if="info.draw_portrait_inactive_tag.inactive_is_married || info.draw_portrait_active_tag.active_is_married"
          >
            <span>不考虑婚姻情况: {{ config.marriage[info.draw_portrait_inactive_tag.inactive_is_married] }}</span>
            <span>优先考虑: {{ config.marriage[info.draw_portrait_active_tag.active_is_married] }}</span>
          </p>
          <p class="flex"
            v-if="(info.draw_portrait_inactive_tag.inactive_salary_min && info.draw_portrait_active_tag.inactive_salary_max) || (info.draw_portrait_active_tag.active_salary_min && info.draw_portrait_active_tag.active_salary_max)"
          >
            <span>不考虑薪资: {{ info.draw_portrait_inactive_tag.inactive_salary_min }}K~{{ info.draw_portrait_inactive_tag.inactive_salary_max }}K</span>
            <span>优先考虑: {{ info.draw_portrait_active_tag.active_salary_min }}K~{{ info.draw_portrait_active_tag.active_salary_max }}K</span>
          </p>
          <p class="flex"
            v-if="(info.draw_portrait_inactive_tag.inactive_age_min && info.draw_portrait_active_tag.inactive_age_max) || (info.draw_portrait_active_tag.active_age_min && info.draw_portrait_active_tag.active_age_max)"
            >
            <span>不考虑年龄: {{ info.draw_portrait_inactive_tag.inactive_age_min }}岁~{{ info.draw_portrait_inactive_tag.inactive_age_max }}岁</span>
            <span>优先考虑: {{ info.draw_portrait_active_tag.active_age_min }}岁~{{ info.draw_portrait_active_tag.active_age_max }}岁</span>
          </p>
          <p class="flex"
            v-if="info.draw_portrait_inactive_tag.inactive_admission_type || info.draw_portrait_active_tag.active_school_type"
          >
            <span>不考虑第一学历: {{ info.draw_portrait_inactive_tag.inactive_admission_type == 1 ? '统招' : '非统招' }}</span>
            <span>优先考虑: {{ school_type[info.draw_portrait_active_tag.active_school_type] }}</span>
          </p>
          <p class="flex" 
            v-if=" info.draw_portrait_inactive_tag.inactive_working_years || info.draw_portrait_active_tag.active_working_years"
          >
            <span>不考虑工作年限: {{ info.draw_portrait_inactive_tag.inactive_working_years }}年以下</span>
            <span>优先考虑: {{ info.draw_portrait_active_tag.active_working_years }}年以上</span>
          </p>
          <p class="flex"
            v-if="info.draw_portrait_inactive_tag.inactive_manage_people || info.draw_portrait_active_tag.active_manage_people"
          >
            <span>不考虑管理人数低于: {{ info.draw_portrait_inactive_tag.inactive_manage_people }}人</span>
            <span>优先考虑: {{ info.draw_portrait_active_tag.active_manage_people }}人</span>
          </p>
          <p class="flex"
            v-if="info.draw_portrait_inactive_tag.inactive_major || info.draw_portrait_active_tag.active_major"
            >
            <span>不考虑非专业: {{ info.draw_portrait_inactive_tag.inactive_major }}</span>
            <span>优先考虑: {{ info.draw_portrait_active_tag.active_major }}</span>
          </p>
          <p class="flex"
            v-if="info.draw_portrait_inactive_tag.inactive_certificate || info.draw_portrait_active_tag.active_certificate"
            >
            <span>不考虑非证书: {{ info.draw_portrait_inactive_tag.inactive_certificate }}</span>
            <span>优先考虑: {{ info.draw_portrait_active_tag.active_certificate }}</span>
          </p>
        </template>
  
      </template>
      <template v-if="type === 'company'">
        <p class="title">公司信息</p>
        <p>
          <b>公司名称：</b>
        </p>
        <p v-html="info.company.name.replace(/\s/g, '<br/>')"></p>
        <p>
          <b>公司简称：</b>
        </p>
        <p v-html="info.company.short_name.replace(/\s/g, '<br/>')"></p>
        <p>
          <b>公司虚名：</b>
        </p>
        <p v-html="info.company.full_name.replace(/\s/g, '<br/>')"></p>
        <p>
          <b>所属行业：</b>
        </p>
        <p v-html="info.company.first_category_name.replace(/\s/g, '<br/>') +'/'+ info.company.second_category_name.replace(/\s/g, '<br/>')"></p>
        <p>
          <b>公司规模：</b>
        </p>
        <p v-html="info.company.scale_name.replace(/\s/g, '<br/>')"></p>
        <p>
          <b>融资阶段：</b>
        </p>
        <p v-html="info.company.financing_stage_name.replace(/\s/g, '<br/>')"></p>
        <p>
          <b>公司福利</b>
        </p>
        <p v-html="info.company.tags.replace(/\s/g, '<br/>')"></p>
        <p>
          <b>公司地址：</b>
        </p>
        <div v-if="info.logo_url">
          <img src="info.company.logo_url" alt />
        </div>
        <p v-html="info.company.address.replace(/\s/g, '<br/>')"></p>
        <p>
          <b>公司介绍：</b>
        </p>
        <p v-html="info.company.introduction.replace(/\s/g, '<br/>')"></p>
      </template>
      <template v-if="type === 'remarks'">
        <p class="title">职位负责IE</p>
        <a-row class="row" type="flex" justify="space-between" align="middle">
          <a-col class="col">中文名：{{ info.ie_user.name }}</a-col>
          <a-col class="col">邮箱：{{ info.ie_user.email }}</a-col>
        </a-row>
        <a-row class="row" type="flex" justify="space-between" align="middle">
          <!--<a-col class="col">-->
          <!--英文名：{{info.ie_user.name}}-->
          <!--</a-col>-->
          <a-col class="col">电话：{{ info.ie_user.tel }}</a-col>
        </a-row>
        <a-divider />
        <p class="title">职位负责BD</p>
        <a-row class="row" type="flex" justify="space-between" align="middle">
          <a-col class="col">中文名：{{ info.bd_ie_user.name }}</a-col>
          <a-col class="col">邮箱：{{ info.bd_ie_user.email }}</a-col>
        </a-row>
        <a-row class="row" type="flex" justify="space-between" align="middle">
          <a-col class="col">电话：{{ info.bd_ie_user.tel }}</a-col>
        </a-row>
        <a-divider />

        <p class="title">面试流程</p>
        <p>面试轮次：{{ info.interview_times_name }}</p>
        <div style="display: flex;align-items: flex-start">
          <div style="white-space: nowrap">面试流程：</div>
          <div>
            <p style="line-height: 24px" v-for="(item, i) in info.job_interviews" :key="i">
              第{{ i + 1 }}轮:
              <br />
              {{ item.content }}
            </p>
          </div>
        </div>
        <a-divider />
        <p class="title">职位卖点</p>
        <p>
          <span v-for="(item, i) in info.selling_point_tags" :key="i">
            {{ item
            }}{{ i != info.selling_point_tags.length - 1 ? "、" : "" }}
          </span>
        </p>
        <a-divider />
        <p class="title">搜寻方向</p>
        <div style="display: flex;align-items: flex-start">
          <div style="white-space: nowrap">第一目标公司：</div>
          <div>
            <p style="line-height: 24px" v-for="(item, i) in info.first_seek_companys" :key="i">
              {{ item.company_name }}
              <br />产品：
              <span v-for="(items, index) in item.seek_products" :key="index">
                {{ items.name
                }}{{ index != item.seek_products.length - 1 ? "、" : "" }}
              </span>
              <br />备注：
              <span>{{ item.notes }}</span>
            </p>
          </div>
        </div>
        <div style="display: flex;align-items: flex-start">
          <div style="white-space: nowrap">第二目标公司：</div>
          <div>
            <p style="line-height: 24px" v-for="(item, i) in info.second_seek_companys" :key="i">
              {{ item.company_name }}
              <br />产品：
              <span v-for="(items, index) in item.seek_products" :key="index">
                {{ items.name
                }}{{ index != item.seek_products.length - 1 ? "、" : "" }}
              </span>
              <br />备注：
              <span>{{ item.notes }}</span>
            </p>
          </div>
        </div>
        <div style="display: flex;align-items: flex-start">
          <div style="white-space: nowrap">其他要求：</div>
          <div>
            <p style="line-height: 24px" >
              {{info.directions}}
            </p>
          </div>
        </div>
        <a-divider />
        <p class="title">招聘原因</p>
        <p>
          <span v-for="(item, index) in info.recruitment_reason_tags" :key="index">{{ item }}</span>
        </p>
        <a-divider />
        <p class="title">职位进展</p>
        <p>
          <span>{{info.recruitment_progress}}</span>
        </p>
        <a-divider />
      </template>
      <template v-if="type === 'grade'">
        <p class="title">职位评级</p>
        <p>
          <b>甲方委托猎企数:</b>
          {{ info.num_published_platforms_name }}
        </p>
        <p>
          <b>面向社会已开放时间:</b>
          {{ info.open_duration_name }}
        </p>
        <p>
          <b>职位紧急程度:</b>
          {{ info.urgency_level_name }}
        </p>
        <p>
          <b>职位难度:</b>
          {{ info.grade }}
        </p>
      </template>
    </div>
  </template>
  
  <script>
  import { mapState } from "vuex";
  import postEdit from '@/app/admin/post/postNew.vue'
  import AITwoDisplayRow from '@/components/ai-two-display-row/index.vue'
  export default {
    name: "info",
    props: {
      type: {
        type: String
      },
      info: {
        type: Object
      }, 
      scrollToDiv: {
        type: String
      }
    },
    components: { postEdit, AITwoDisplayRow },
    data() {
      return {
        job_hopping_interval: [ '', '5年2跳', '5年3跳', '3年1跳', '5年1跳' ],
        zodiac_sign: ["鼠","牛","虎","兔","龙","蛇","马","羊","猴","鸡","狗","猪"],
        school_type: ['普通高校', '211院校', '985院校', '985/211', '外国院校'],
        // school_type: ['普通高校', '211院校', '985院校', '985/211', '外国院校'],
        salary_benefits: {},
        candidateEdit : false
      }
    },
    computed: {
      ...mapState([ 'config' ]),
    },
    created() {
      console.log(this.info);
      this.salary_benefits = this.info.salary_benefits ? JSON.parse(this.info.salary_benefits) : undefined;
    },
    mounted() {
      console.log(this.info, 'info');

      // setTimeout(() => {
        // 这里写需要延时执行的逻辑代码
      if (this.scrollToDiv == 'candidate'){
        this.scrollToCandidate('#candidate');
      }

      // }, 10000); // 设置延时时间为1秒（单位为毫秒）

    },
    methods: {
      editFinish(val){
        console.log("编辑成功, 通知详情页刷新");
        this.candidateEdit = false;
        this.$emit('refresh', {})

      },
      scrollToCandidate(selector) {
        this.$nextTick(() => {
          document.querySelector(selector).scrollIntoView({
                behavior: "smooth"
           });

        });
       
      },
      editCancelAct(e){
        this.candidateEdit = false;
      },
      editDoneAct(e){
        // this.candidateEdit = false;
        this.$refs.candidateRef.handleSubmit();

      },
      editAct(e){
        this.candidateEdit = true;
      },
      handleShool(status){
        let value = "无";
        switch (status){
          case '0':
            value = "不限";
            break;
          case '1':
            value = "211/985";
            break;
          case '2':
            value = "海归";
            break;
          default:
            value = "不限";
            break;
        }
        return value;
      },
      handleGender(status){
        let value = "无";
        switch (status){
          case '0':
            value = "不限";
            break;
          case '1':
            value = "男";
            break;
          case '2':
            value = "女";
            break;
          default:
            value = "--";
            break;
        }
        return value;
      },
      handleIsTongZhao(status){
        if (status == '1' ){
          return "必须是";
        }else if (status == '2'){
          return "无所谓";
        }else{
          return "--";
        }
      },
      handleLanguage(data) {
        if(!data) return '--';
        let arr;
        if (typeof data === 'string'){
          if (data == '[]'){
            return '--';
          }
          let res = JSON.parse(data);
          if (res){
            arr = res;
          }else{
            return data;
          }
        }else if (Array.isArray(data)){
          arr = data;
        }
        let str = '';
        arr.forEach(x => {
          str += x +'|'
        });
        return str.substring(0, str.length-1);
      },
      handleBorn(data, type) {
        let born = data;
        if(type == 'inactive') {
          let city_name = born.inactive_born_province_name === born.inactive_born_city_name ? born.inactive_born_province_name : born.inactive_born_province_name + '、' + born.inactive_born_city_name;
          return city_name + '、' + born.inactive_born_dist_name;
        } else {
          let city_name = born.active_born_province_name === born.active_born_city_name ? born.active_born_province_name : born.active_born_province_name + '、' + born.active_born_city_name;
          return city_name + '、' + born.active_born_dist_name;
        }
      },
      handleIndustry(data) {
        console.log("sky log industry: " + data);
        if(data && data.length) {
          let industry = '';
          data.forEach( x => {
            industry += (x.fourth_industry_name || x.third_industry_name || x.second_industry_name || x.first_industry_name) + ' ';
          })
          return industry;
        } else {
          return '';
        }
      }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .info {
      // background-color: red;
      padding: 30px 10px;
      text-align: left;
      p {
        margin-bottom: 25px;
        line-height: 18px;
        &.title {
        font-weight: bold;
        font-size: 16px;
        &.inline {
        float: left;
        margin-right: 5px;
        margin-bottom: 15px;
        }
      }
    }
    .flex {
      display: flex;
      justify-content: left;
      align-content: left;
      }
    }
  </style>
  